import React, {ReactNode, ReactNodeArray, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ElectricCompanyLeadData from '../../../Models/Content/ElectricCompanyLeadBlockData';
import ElectricCompanyLead from './ElectricCompanyLead';

export default class ElectricCompanyLeadBlock extends EpiComponent<ElectricCompanyLeadData>
{
    constructor(props) {
        super(props);
    }

    public render() : ReactNode | ReactNodeArray | null
    {
        return (
            <ElectricCompanyLead context={this.getContext()} iContent={this.props.data}/>
        );
    }
}
